import React, { memo } from 'react'
import { useSelector } from 'react-redux'

import { Checkbox, Typography } from '../index'
import { util } from '../../../util'

const RegionCheckboxes = ({ regionSelectHandler, selectedList, regionsList, className, name }) => {
    const regions = useSelector(({ common }) => common.adp_configurations.regions)

    return (
        <div className={util.joinClasses('region-checkboxes', className)}>
            {regionsList.map(({ state, country }) => {
                const label = regions[state]
                return (
                    <div className="flex">
                        <Checkbox
                            checked={selectedList.some(val => val.state === state)}
                            key={state}
                            id={`${country}_${state}`}
                            onChange={regionSelectHandler}
                            name={name}
                        />
                        <Typography text={label} className={'px-2'} />
                    </div>
                )
            })}
        </div>
    )
}

export default memo(RegionCheckboxes)
